<template>
  <div>
    <common-dialog ref="dialog" width="1300px" title="按设备查看" id-key="UserId" :data="data" @close-saved="$emit('close-saved')" @details-opened="detailsOpened" @edit-opened="onEditOpened">
      <!-- :get-data-func="api.info" -->
      <div class="row-tb-head" style="margin-top: 10px">
        <span>未排产工单</span>
      </div>
      <el-table class="table_bottom table-line tb-c-head" border :data="notCurrentData">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="OrderNo" label="订单号"></el-table-column>
        <el-table-column prop="WorkDocNo" label="工单号"></el-table-column>
        <el-table-column prop="DocDate" label="单据日期">
          <template slot-scope="{ row }">
            <span>{{ $dayjs(new Date(row.DocDate).getTime()).format('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProductNo" label="产品编码"></el-table-column>
        <el-table-column prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column prop="Quantity" label="数量"></el-table-column>
        <el-table-column prop="MaintenanceName" label="设备"></el-table-column>
        <el-table-column prop="Team" label="班组"></el-table-column>
        <el-table-column prop="Schedule" label="班次"></el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top: 10px;float: right;"
        @size-change="notHandleSizeChange"
        @current-change="notHandleCurrentChange"
        :current-page="notCurrentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="notPageSize"
        layout="sizes, prev, pager, next, total, jumper"
        :total="notTotal"
      >
      </el-pagination>

      <div class="row-tb-head" style="margin-top: 10px">
        <span>已排产工单</span>
      </div>
      <el-table class="table_bottom table-line tb-c-head" border :data="CurrentData">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="OrderNo" label="订单号"></el-table-column>
        <el-table-column prop="WorkDocNo" label="工单号"></el-table-column>
        <el-table-column prop="DocDate" label="单据日期">
          <template slot-scope="{ row }">
            <span>{{ $dayjs(new Date(row.DocDate).getTime()).format('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProductNo" label="产品编码"></el-table-column>
        <el-table-column prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column prop="Quantity" label="数量"></el-table-column>
        <el-table-column prop="MaintenanceName" label="设备"></el-table-column>
        <el-table-column prop="Team" label="班组"></el-table-column>
        <el-table-column prop="Schedule" label="班次"></el-table-column>
        <el-table-column label="完工状态">
          <template slot-scope="{ row }">
            <span>{{ row.SchedulingStatus == 0 ? '未动工' : row.SchedulingStatus == 1 ? '报工中' : '已完工' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SchedulingDate" label="排产开工时间"></el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top: 10px;float: right;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="PageSize"
        layout="sizes, prev, pager, next, total, jumper"
        :total="Total"
      >
      </el-pagination>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

import { historicalschedulingApi } from '@/data/production/test'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      api: require('@/api/pu/PlanHistoryDts').default,
      // api: historicalschedulingApi,
      data: {},
      notData: [],
      alreadyData: [],
      // 未排产工单分页
      notCurrentData: [],
      notCurrentPage: 1,
      notTotal: 0,
      notPageSize: 5,
      // 已排产工单分页
      CurrentData: [],
      CurrentPage: 1,
      Total: 0,
      PageSize: 5
    }
  },
  methods: {
    detailsOpened(data) {
      // this.notData = data.notData;
      // this.alreadyData = data.alreadyData;
    },
    onEditOpened(data) {
      this.alreadyData = []
      this.notData = []
      this.notTotal = 0
      this.notCurrentData = []
      this.Total = 0
      this.CurrentData = []
      this.api
        .list({ PlanHistoryId: data.PlanHistoryId, SchedulingType: 1 })
        .then(res => {
          res.Data.forEach(item => {
            if (item.IsScheduling) {
              this.alreadyData.push(item)
            } else {
              this.notData.push(item)
            }
            // 未排产工单分页
            this.notTotal = this.notData.length
            this.notCurrentData = this.notData.slice((this.notCurrentPage - 1) * this.notPageSize, (this.notCurrentPage - 1) * this.notPageSize + this.notPageSize)
            // 已排产工单分页
            this.Total = this.alreadyData.length
            this.CurrentData = this.alreadyData.slice((this.CurrentPage - 1) * this.PageSize, (this.CurrentPage - 1) * this.PageSize + this.PageSize)
          })

        })
        .catch(err => {
          console.log(err)
          this.$message.error(res.Msg)
        })
    },
    // 未排产分页
    notHandleCurrentChange(val) {
      this.notCurrentPage = val
      this.notCurrentData = this.notData.slice((this.notCurrentPage - 1) * this.notPageSize, (this.notCurrentPage - 1) * this.notPageSize + this.notPageSize)
    },
    notHandleSizeChange(val) {
      this.notPageSize = val
      this.notCurrentData = this.notData.slice((this.notCurrentPage - 1) * this.notPageSize, (this.notCurrentPage - 1) * this.notPageSize + this.notPageSize)
    },
    // 已排产分页
    handleCurrentChange(val) {
      this.CurrentPage = val
      this.CurrentData = this.alreadyData.slice((this.CurrentPage - 1) * this.PageSize, (this.CurrentPage - 1) * this.PageSize + this.PageSize)
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.CurrentData = this.alreadyData.slice((this.CurrentPage - 1) * this.PageSize, (this.CurrentPage - 1) * this.PageSize + this.PageSize)
    }
  }
}
</script>

